import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { answerQuestionRequested } from 'features/qa/actions';

export function* answerQuestionSaga(action: ReturnType<typeof answerQuestionRequested>) {
  yield call(SignalingSocket.send, {
    event: 'answerQuestion',
    data: {
      answer: action.payload.answer,
      private: action.payload.privateAnswer,
      questionId: action.payload.questionId,
    },
  });
}
